import { Routes, Route } from "react-router-dom";
import {
  FinancialGoals,
  Footer,
  Home,
  MutualFundPage,
  WhoWeHelp,
  WhyChoose,
  HowWeHelp,
} from "./sections";

import SipCalculator from "./Pages/SipCalculator";
import ContactUsPage from "./Pages/ContactUsPage";
import InsurancePage from "./Pages/InsurancePage";
import FreePortfolioCheck from "./Pages/FreePortfolioCheck";
import SuggestMutualFundFlow from "./Pages/SuggestMutualFundFlow";
import PartnerRedirect from "./components/PartnerRedirect";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <section className="padding">
              <Home />
            </section>
            <section className="padding">
              <HowWeHelp />
            </section>

            <section className="padding">
              <WhoWeHelp />
            </section>

            <section className="padding">
              <WhyChoose />
            </section>

            <section className="padding">
              <FinancialGoals />
            </section>

            <section className="padding bg-black-main-dark">
              <Footer />
            </section>
          </>
        }
      />

      <Route path="/open-account" element={<PartnerRedirect />} />

      {/* Mutual Fund Page */}
      <Route
        path="/mutual-funds"
        element={
          <>
            <section className="padding">
              <MutualFundPage />
            </section>
            <section className="padding bg-black-main-dark">
              <Footer />
            </section>
          </>
        }
      />
      {/* Free Portfolio Check */}
      <Route path="/free-portfolio-check" element={<FreePortfolioCheck />} />

      {/* Mutual Fund Check */}
      <Route path="/mutual-fund-check" element={<SuggestMutualFundFlow />} />

      {/* Insurance */}
      <Route path="/insurance" element={<InsurancePage />} />
      {/* SIP Calculator */}
      <Route path="/sip-calculator" element={<SipCalculator />} />
      {/* Contact */}
      <Route
        path="/contact"
        element={
          <>
            <section className="padding">
              <ContactUsPage />
            </section>
            <section className="padding bg-black-main-dark">
              <Footer />
            </section>
          </>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
